export enum Logic {
  AND = "and",
  OR = "or",
}
